import { useContext } from 'react';
import { AppContext, type AppContextType } from '../contexts/AppContext';

export function useAppContext(): AppContextType {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppProvider');
  return ctx;
}

